import { useState } from "react"
import { PiMagnifyingGlassDuotone } from 'react-icons/pi'
import { FiLoader } from 'react-icons/fi'
import api from '../../../utils/api'
import useFlashMessage from '../../../hooks/useFlashMessage'

import '../../css/inputGroup.css'

// Campo de CEP com um botão de busca colado — consulta o ViaCEP (via backend) e devolve
// o endereço achado pro chamador preencher os campos do jeito que fizer sentido pra ele
// (nomes de campo diferem entre Cliente e destinatário da nota, por isso o callback
// genérico em vez de mexer direto num objeto de estado específico).
function CepSearchTrigger({ name, value, handleOnChange, onFound }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [searching, setSearching] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    async function search() {
        const digits = (value || '').replace(/\D/g, '')
        if (digits.length !== 8) {
            setFlashMessage('Digite um CEP válido (8 dígitos)', 'error')
            return
        }

        setSearching(true)
        const data = await api.get(`/cep/${digits}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            return err.response?.data || null
        })
        setSearching(false)

        if (!data || !data.street) {
            setFlashMessage((data && data.message) || 'CEP não encontrado', 'error')
            return
        }

        onFound(data)
    }

    return (
        <div className="ncm-input-group">
            <input className="input ncm-input-group-input" type="text" name={name} value={value || ''} onChange={handleOnChange} />
            <button type="button" className="ncm-input-group-btn" title="Buscar endereço pelo CEP" onClick={search} disabled={searching}>
                {searching
                    ? <FiLoader size={20} className="ncm-input-group-spin" />
                    : <PiMagnifyingGlassDuotone size={23} />
                }
            </button>
        </div>
    )
}

export default CepSearchTrigger
